import { Checkbox, FormLabel, Link } from '@chakra-ui/react';
import { useInvestorAccountModel } from '@common/models/InvestorAccountModel';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { LINKS } from 'src/apps/invest/config';
import { useCheckoutCashflowViewModel } from '../../../models/CheckoutCashflowViewModel';

type AgreementProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Agreement: React.FC<AgreementProps> = ({ onChange }) => {
  const model = useCheckoutCashflowViewModel();
  const investorAccountModel = useInvestorAccountModel();
  const isAccreditedInvestor = investorAccountModel.isAccreditedInvestor();
  const subscriptionAgreement = investorAccountModel.subscriptionOffer?.subscription_doc?.download_url ?? '';
  const hasAnsweredBrokerDealerQuestion =
    investorAccountModel?.investorAccount?.non_accredited_survey_v2?.broker_dealer_assoc?.value ?? null !== null;
  const isBrokerDealer = Boolean(
    investorAccountModel?.investorAccount?.non_accredited_survey_v2?.broker_dealer_assoc?.value ?? false,
  );

  return (
    <>
      {/* Only non-accredited investors should see this checkbox */}
      {!isAccreditedInvestor && (
        <FormLabel display={'flex'} alignItems={'flex-start'} gap="20px" flexDirection="row" cursor={'pointer'}>
          <Checkbox
            isChecked={model.confirmAgreement}
            onChange={onChange}
            iconSize={'30px'}
            size="lg"
            mt={'4px'}></Checkbox>
          {!hasAnsweredBrokerDealerQuestion ? (
            <TextBlock fontSize="16px" color="blackAlpha.700">
              You represent that you are not affiliated with a broker-dealer and that your investment(s) in this
              offering(s) does not constitute more than the greater of 10% of your gross annual income or net worth,
              either individually or in the aggregate.
            </TextBlock>
          ) : isBrokerDealer ? (
            <TextBlock fontSize="16px" color="blackAlpha.700">
              You represent that your investment(s) in this offering(s) does not constitute more than the greater of 10%
              of your gross annual income or net worth, either individually or in the aggregate.
            </TextBlock>
          ) : (
            <TextBlock fontSize="16px" color="blackAlpha.700">
              You represent that you are not affiliated with a broker-dealer and that your investment(s) in this
              offering(s) does not constitute more than the greater of 10% of your gross annual income or net worth,
              either individually or in the aggregate.
            </TextBlock>
          )}
        </FormLabel>
      )}

      {/* ACH Agreement */}
      <TextBlock fontSize="16px" color="blackAlpha.700">
        By confirming, you are authorizing us to intiate an ACH transfer on your behalf based on our{' '}
        <Link href={LINKS.EFT_POLICY} target="_blank">
          Electronic Funds Transfer policy
        </Link>
        .
      </TextBlock>

      {/* TODO: AutoInvest Subscription Agreement */}

      {/* TODO: Goals Agreement */}

      {/* One-Time Investment Subscription Disclaimer */}
      <TextBlock fontSize="16px" color="blackAlpha.700">
        You are acknowledging that all the information you provided is correct & current. In addition, you are agreeing
        to use your stored e-signature in accordance with our{' '}
        <Link href={LINKS.ESIGN} target="_blank">
          E-Signature Policies
        </Link>{' '}
        to sign the associated{' '}
        <Link href={subscriptionAgreement} target="_blank">
          Subscription Agreement
        </Link>{' '}
        with this Offering for <i>{investorAccountModel.subscriptionOffer?.display_name}</i>
      </TextBlock>
    </>
  );
};
